export default __webpack_public_path__ + "static/media/About-Us.77676c68.jpg";